const constraints = {
  username: {
    presence: {
      allowEmpty: false,
      message: '^Please enter Username',
    },
    // format: {
    //   pattern: '/^[a-zA-Z0-9!@#\\+=._]+',
    //   flags: 'i',
    //   message: 'can only contain [a-z0-9./@$]',
    // },
    type: 'string',
  },
  full_name: {
    type: 'string',
    presence: {
      allowEmpty: false,
      message: '^Please enter valid name',
    },
    format: {
      pattern: '[a-z0-9 ]+',
      flags: 'i',
      message: 'can only contain a-z and 0-9',
    },
  },
  email: {
    presence: {
      allowEmpty: false,
      message: '^Please enter valid email',
    },
    email: true,
  },
  mobile: {
    type: 'string',
    format: {
      pattern: '[0-9]+',
      flags: 'i',
      message: '^Please enter valid mobile no.',
    },
    length: {
      minimum: 10,
      maximum: 10,
      message: '^Please enter valid mobile no.',
    },
  },
  password: {
    presence: {
      allowEmpty: false,
      message: '^Please enter password',
    },
    type: 'string',
  },
};

export default constraints;
